module.exports = __webpack_public_path__ + "static/media/alprints.47909bc3.jpg";